import React, {lazy, Suspense} from 'react'

const ChurchMassTimeSearchViewLazy = lazy(() =>
    import('./ChurchMassTimeSearchView')
)

const ChurchMassTimeSearchView = props => (
    <Suspense fallback={null}>
        <ChurchMassTimeSearchViewLazy {...props} />
    </Suspense>
)

export default ChurchMassTimeSearchView
